import {MAT_DATE_LOCALE} from '@angular/material/core';
import {Inject, Injectable, Optional} from '@angular/core';
import {DateFnsAdapter} from '@angular/material-date-fns-adapter';

@Injectable()
export class CovDateAdapter extends DateFnsAdapter {
  constructor(@Optional() @Inject(MAT_DATE_LOCALE) matDateLocale: string) {
    super(matDateLocale);
  }

  override getDayOfWeekNames(): string[] {
    return super.getDayOfWeekNames('short');
  }

  override getFirstDayOfWeek(): number {
    if (this.locale.code === 'de') {
      return 1;
    }

    return 0;
  }
}
